<script setup lang="ts">
withDefaults(defineProps<{
  type?: string
  width?: string | number
  height?: string | number
  boilerplate?: boolean
}>(), {
  type: 'text',
})

const typeMap: Record<string, { width: string; height: string; borderRadius: string }> = {
  text: { width: '100%', height: '16px', borderRadius: '4px' },
  heading: { width: '70%', height: '24px', borderRadius: '4px' },
  chip: { width: '80px', height: '30px', borderRadius: '15px' },
  button: { width: '120px', height: '40px', borderRadius: '8px' },
  avatar: { width: '40px', height: '40px', borderRadius: '50%' },
  image: { width: '100%', height: '200px', borderRadius: '8px' },
  card: { width: '100%', height: '180px', borderRadius: '8px' },
  'card-avatar': { width: '100%', height: '80px', borderRadius: '8px' },
  'list-item': { width: '100%', height: '48px', borderRadius: '4px' },
  'list-item-avatar': { width: '100%', height: '56px', borderRadius: '4px' },
  'list-item-two-line': { width: '100%', height: '64px', borderRadius: '4px' },
  'list-item-three-line': { width: '100%', height: '80px', borderRadius: '4px' },
  'table-row': { width: '100%', height: '48px', borderRadius: '0' },
  'table-heading': { width: '100%', height: '40px', borderRadius: '0' },
  paragraph: { width: '100%', height: '80px', borderRadius: '4px' },
  sentences: { width: '100%', height: '48px', borderRadius: '4px' },
  article: { width: '100%', height: '240px', borderRadius: '8px' },
  ossein: { width: '100%', height: '300px', borderRadius: '8px' },
}
</script>

<template>
  <div
    class="m-skeleton"
    :class="{ 'm-skeleton--boilerplate': boilerplate }"
    :style="{
      width: width ? (typeof width === 'number' ? `${width}px` : width) : typeMap[type]?.width,
      height: height ? (typeof height === 'number' ? `${height}px` : height) : typeMap[type]?.height,
      borderRadius: typeMap[type]?.borderRadius || '4px',
    }"
  />
</template>

<style scoped>
.m-skeleton {
  background: linear-gradient(90deg, var(--m-surface-variant) 25%, var(--m-border-light) 50%, var(--m-surface-variant) 75%);
  background-size: 200% 100%;
  animation: m-skeleton-pulse 1.5s ease-in-out infinite;
}

.m-skeleton--boilerplate {
  background: var(--m-surface-variant);
  animation: none;
}

@keyframes m-skeleton-pulse {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}
</style>
